import { Injectable } from '@angular/core';

import { ConfigParserService } from '../shared/services/config-parser.service';

export interface BannerConfig {
    resources: BannerResources;
}

export interface BannerResources {
    AddButtonText: string;
    AddButtonDesktopText: string;
    AssignProductsButtonAriaLabel: string;
    AssignProductsButtonText: string;
    AssignProductsButtonUrl: string;
    A2HSButtonAriaLabel: string;
    A2HSButtonAriaLabelDesktop: string;
    A2HSPromptTitle: string;
    A2HSPromptTitleDesktop: string;
    DismissAnnouncementAriaLabel: string;
    DismissAnnouncementButtonText: string;
    IE11EOSAnnouncementTitle: string;
    IE11EOSAnnouncementSubTitle: string;
    IE11EOSButtonText: string;
    IE11EOSButtonAriaLabel: string;
    IE11EndOfSupportRedirectUrl: string;
    MissingPuidAnnouncementSubTitle: string;
    MissingPuidAnnouncementTitle: string;
    NoLicenseAdminViewSubTitle: string;
    NoLicenseAdminViewTitle: string;
    NoLicenseAdminView2SubTitle: string;
    NoLicenseAdminView2Title: string;
    NoLicenseUserViewSubTitle: string;
    NoLicenseUserViewTitle: string;
    OfflineModeMessage: string;
    SessionExpiredAnnouncementTitle: string;
    SessionExpiredButtonTitle: string;
    TrialAnnouncementBuyButtonAriaLabel: string;
    TrialAnnouncementBuyButtonText: string;
    TrialAnnouncementDelayButtonText: string;
    TrialUserAnnouncementExpiredTitle: string;
    TrialUserAnnouncementRemainingDaysTitle: string;
    TrialUserAnnouncementRemainingOneDayTitle: string;
    TrialUserAnnouncementSubTitle: string;
    TrialUserAnnouncementTitle: string;
}

@Injectable({
    providedIn: 'root'
})
export class BannerConfigService {
    public readonly config: BannerConfig;

    constructor(configParserService: ConfigParserService) {
        this.config = configParserService.parse<BannerConfig>('bannerConfig');
    }
}
